import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { SshSecurityInfo } from 'data/sshSecurityInfo/sshSecurityInfo.types';

export enum SshSecurityInfoActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newSshSecurityInfo: SshSecurityInfo = {
  id: '',
  SS8ID: '',
  SSHTYPE: 'SERVER',
  AUTHTYPE: 'PASSWORD',
  USERNAME: '',
  PASSWORD: '',
  PRIVKEYFILENAME: '',
  PASSPHRASE: '',
  PUBKEYFILENAME: '',
  SSHDIR: '',
  HOSTKEYTYPE: 'RSA',
};

export const sshSecurityInfoColumnDefs: ColDef[] = [

    {
      headerName: i18n.t('sshSecurityInfo.grid.sshCredId'),
      field: 'SS8ID',
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      resizable: true,
      tooltipField: 'name',
      flex: 1,
      minWidth: 165,
      maxWidth: 165,
    },
    {
      headerName: i18n.t('sshSecurityInfo.grid.typeInterface'),
      field: 'SSHTYPE',
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      resizable: true,
      tooltipField: 'description',
      flex: 1,
      minWidth: 165,
      maxWidth: 165,
    },
    {
      headerName: i18n.t('sshSecurityInfo.grid.authType'),
      field: 'AUTHTYPE',
      sortable: true,
      resizable: true,
      tooltipField: 'intfType',
      flex: 1,
      minWidth: 165,
      maxWidth: 165,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('sshSecurityInfo.grid.sshUserName'),
      field: 'USERNAME',
      sortable: true,
      resizable: true,
      tooltipField: 'tlsVersion',
      flex: 1,
      minWidth: 165,
      maxWidth: 165,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
];
